<template>
  <div>
    <div class="w980 clearfix">
      <a href="http://www.romleyuan.com">
        <img src="@/assets/images/romleyuan.jpg" alt="海量ROM" style="width: 100%;" />
      </a>
    </div>
    <!-- <div id="pcList" class="videoList-container" style="display: block; margin-bottom: 0px;">
      <div id="slide-index">
        <div class="slides">
          <div
            class="slide autoMaxWidth"
            links="[{left:'30px',top:'81px'},{left:'30px',top:'244px'},{direction:'tb'}]"
          >
            <div id="bi_0" class="image" style="background-color: #f3d03e;">
              <a href="http://www.mgyun.com/activity/2year" target="_blank">
                <img name src="/static/images/FF2.jpg" />
              </a>
            </div>
            <div id="bt_0" class="text"></div>
            <div id="bb_0" class="button"></div>
          </div>
          <div
            class="slide autoMaxWidth"
            links="[{left:'30px',top:'81px'},{left:'30px',top:'244px'},{direction:'tb'}]"
          >
            <div id="bi_1" class="image" style="background-color: #328F97;">
              <a href="http://www.mgyun.com/activity/2year/cpartners" target="_blank">
                <img name src="/static/images/cpartners.jpg" />
              </a>
            </div>
            <div id="bt_1" class="text"></div>
            <div id="bb_1" class="button"></div>
          </div>
          <div
            class="slide autoMaxWidth"
            links="[{left:'30px',top:'81px'},{left:'30px',top:'244px'},{direction:'tb'}]"
          >
            <div id="bi_2" class="image" style="background-color: #0f8ad0;">
              <a href="http://links.mgyun.com/fw/113" target="_blank">
                <img name src="/static/images/xiaocai.jpg" />
              </a>
            </div>
            <div id="bt_2" class="text"></div>
            <div id="bb_2" class="button"></div>
          </div>
        </div>
        <div class="control">
          <div>
            <a href></a>
            <a href></a>
            <a href></a>
          </div>
        </div>
        <div class="xia">
          <div class="w980 clearfix">
            <div id="image2" class="dib">
              <div
                class="pcr fr"
                onclick="document.getElementById('image2').className='din';document.getElementById('image1').className='dib'"
              ></div>
              <div class="dow zai fr">
                <a href>
                  <dl>
                    <dt>
                      <strong>刷机大师下载</strong>
                    </dt>
                    <dd>
                      <span>电脑版</span>
                    </dd>
                  </dl>
                </a>
              </div>
            </div>
            <div id="image1" class="din">
              <div class="dwo zai fr">
                <a href>
                  <img alt="刷机大师手机版下载" src="/static/images/erweima.png" />
                </a>
                <a href>
                  <dl>
                    <dt>
                      <strong>刷机大师下载</strong>
                    </dt>
                    <dd>
                      <span>手机版</span>
                    </dd>
                  </dl>
                </a>
              </div>
              <a
                href="javascript:void(0)"
                class="pcl fr"
                onclick="document.getElementById('image1').className='din';document.getElementById('image2').className='dib'"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="w980 product clearfix">
      <ul>
        <li class="cp1">
          <a href="http://www.romleyuan.com/" target="_blank"></a>
          <!-- <router-link :to="'/function/romasterlab'" title="点击此处一键刷机"></router-link> -->
        </li>
        <li class="cp2">
          <a href="http://www.romleyuan.com/" target="_blank"></a>
          <!-- <router-link :to="'/function/vroot'" target="_blank" title="成功率超高的一键ROOT工具"></router-link> -->
        </li>
        <li class="cp3">
          <a href="http://www.romleyuan.com/" target="_blank"></a>
          <!-- <router-link :to="'/function/romjd'" title="海量ROM"></router-link> -->
        </li>
        <li class="cp4">
          <a href="http://www.romleyuan.com/" target="_blank"></a>
          <!-- <router-link :to="'/function/supercleaner'" title="安卓清理大师下载"></router-link> -->
        </li>
        <li class="cp5">
          <a href="http://www.romleyuan.com/" target="_blank"></a>
          <!-- <router-link :to="'/function/romasterlab'" title="一键刷机软件下载"></router-link> -->
        </li>
        <li class="cp6">
          <a href="http://www.romleyuan.com/" target="_blank"></a>
        </li>
      </ul>
    </div>
    <!-- <div class="w980 mt25 pt3 clearfix">
      <div class="w300 fl mr40">
        <h2 class="bt bt1">
          <span>大师视频</span>
        </h2>
        <div class="video mt10">
          <img alt="大师视频" src="/static/images/video.jpg" />
          <p></p>
        </div>
      </div>
      <div class="w300 fl mr40">
        <h2 class="bt bt1">
          <span>新闻中心</span>
          <a href="http://www.mgyun.com/news/" class="more mo01" target="_blank"></a>
        </h2>
        <ul class="v100 mt5 news">
          <li>暂无更新</li>
        </ul>
      </div>
      <div class="w300 fr bgea">
        <h2 class="bt bt2">
          <span>产品动态</span>
          <a href="http://www.romjd.com/reviews" class="more mo01" target="_blank"></a>
        </h2>
        <ul class="dongtai lh26 fs14">
          <li>暂无更新</li>
        </ul>
      </div>
      <div class="hezuo mt40 v100 fl pb20 mb20">
        <h2 class="mt10 fl v100 pb12">
          <span>合作伙伴</span>
        </h2>
        <div class="rollBox fl">
          <a
            class="L pngbg"
            onmousedown="ISL_GoUp()"
            onmouseup="ISL_StopUp()"
            onmouseout="ISL_StopUp()"
          ></a>
          <div id="ISL_Cont" class="Cont">
            <div class="ScrCont">
              <ul id="List1"></ul>
              <ul id="List2"></ul>
            </div>
          </div>
          <a
            class="R pngbg"
            onmousedown="ISL_GoDown()"
            onmouseup="ISL_StopDown()"
            onmouseout="ISL_StopDown()"
          ></a>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue